import { render, staticRenderFns } from "./XOLRecoveryDetail.vue?vue&type=template&id=c97ddf46&"
import script from "./XOLRecoveryDetail.vue?vue&type=script&lang=js&"
export * from "./XOLRecoveryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports